<template>
  <div class="avue-logo">
    <transition name="fade">
      <span class="avue-logo_subtitle" key="0" v-if="keyCollapse">
        {{ website.logo }}
      </span>
    </transition>
    <transition-group name="fade">
      <template v-if="!keyCollapse">
        <span class="avue-logo_title" key="1">{{ website.indexTitle }} </span>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "logo",
  data() {
    return {
      shopId: this.$store.getters.shopId
    };
  },
  computed: {
    ...mapGetters(["website", "keyCollapse"])
  },
  methods: {}
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active {
  transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.avue-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  height: 60px;
  line-height: 60px;
  background-color: #00284d;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;

  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 16px;
  }

  &_subtitle {
    display: block;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  .avue-logo_title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
  }
}
</style>
